import { brandIcons } from "@hiver/hiver-ui-kit";
import { config } from "../../../../config";
import { UPGRADE_BUTTON_CLICKED_EVENTS } from "../../../common/constants/commonGainsightEvents";
import { CHANNEL_TYPE_AIRCALL, CHANNEL_TYPE_CHAT, CHANNEL_TYPE_WHATSAPP } from "../../../sharedmailbox/common/constants";

export const CHANNEL_TYPE = "channel";
export const FEATURE_TYPE = "feature";
export const CHANNEL_GROUP = "channelGroup";
export const TEAM_GROUP = "teamGroup";
export const INTEGRATION_GROUP = "integrationGroup";
export const COMBINED_INTEGRATION_GROUP = "combinedIntegrationGroup";
export const CONNECTORS_GROUP = "connectorsGroup";
export const UPGRADE_URL_PATH = "/app/settings/account/upgrade";
export const CREATE_SM_URL_PATH = "/app/sharedmailbox/create";
export const CREATE_CHAT_URL_PATH = "/app/sharedmailbox/chat/create/generalInformation";
export const CREATE_WHATSAPP_URL_PATH = "/app/sharedmailbox/create";
export const CREATE_AIRCALL_URL_PATH = "/app/sharedmailbox/voice/create/setup";
export const CREATE_SL_URL_PATH = "/app/sharedlabels/create?method=Create&fromHomePage=true";
export const FEATURES_URL_PATH = "/app/settings/features";
export const CONNECTORS_URL_PATH = "/app/custom-connectors"

export const CHANNEL_TYPE_EMAIL = 'email';
export const CHANNEL_TYPE_VOICE = 'voice';
export const CHANNEL_TYPE_KNOWLEDGE_BASE = 'Knowledge Base';
export const FEATURE_TYPE_ZAPIER = 'zapier';
export const FEATURE_TITLE_CUSTOM_CONNECTOR = 'Custom Connectors';
export const FEATURE_TITLE_AUTO_RESPONDER = 'Auto Responder';
export const FEATURE_TITLE_CUSTOM_FIELDS = 'Custom fields';
export const SHARED_MAILBOX = 'SM';
export const SHARED_LABEL = 'SL';
export const SL_SUBCARD_CLICKED = 'ad_lp_SL_subcard';
export const SL_SUBCARD_LEARN_MORE_CLICKED = 'ad_lp_SL_learnmore';
export const SL_CREATE_CLICKED = 'ad_lp_create_SL';
export const INBOX_SELECTOR_DEFAULT_TITLE = "Select the shared inbox";
export const GUIDE_TO_QUERY_STRING = "guideTo";
export const POPUP_TYPE_QUERY_STRING = "popupType";

export const CREATE_URL_BY_CHANNEL = {
    [CHANNEL_TYPE_EMAIL]: CREATE_SM_URL_PATH,
    [CHANNEL_TYPE_CHAT]: CREATE_CHAT_URL_PATH,
    [CHANNEL_TYPE_WHATSAPP]: CREATE_WHATSAPP_URL_PATH,
    [CHANNEL_TYPE_AIRCALL]: CREATE_AIRCALL_URL_PATH,
}

export const LIMIT_ALERT_MODAL = {
    title: "Upgrade to create more shared inboxes",
    description: "You have reached the maximum limit of inboxes allowed as per your plan. Upgrade or contact support@hiverhq.com for assistance.",
    btnText: "Upgrade now",
    buttonClickEvent: UPGRADE_BUTTON_CLICKED_EVENTS.SM_LIMIT_CROWN_CARD_CLICKED,
}

export const SL_LIMIT_ALERT = (slLimit) => ({
    title: "Upgrade to create more shared labels",
    description: `You've reached the maximum number of shared labels (${slLimit}) allowed in your plan. Please upgrade your plan to avail higher limits.`,
    btnText: "Upgrade now",
})

export const CREATE_INBOX_MODAL = {
    'Admin': {
            title: 'Create inbox',
            description: 'Create an email shared inbox first to use this feature',
            btnText: 'Create',
    },
    'NonAdminRole' : {
                    title: 'Create inbox',
                    description: 'Contact your admin to create an email shared inbox first',
                    btnText: 'Okay',
    },
};

export const CREATE_CHAT_INBOX_MODAL = {
    'Admin': {
            title: 'Create chat inbox',
            description: 'Create a chat inbox first to use this feature',
            btnText: 'Create',
    },
    'NonAdminRole' : {
                    title: 'Create chat inbox',
                    description: 'Contact your admin to create a chat inbox first',
                    btnText: 'Okay',
    },
};

export const CONTACT_ADMIN_MODAL = {
    title: 'Contact admin',
    description: 'Please contact your account admin to upgrade your plan',
    btnText: 'Okay',
}

export const EMAIL_CHANNEL_OPTIONS_MODAL = {
    title: "Engage with your customers through email",
    options: [
        {
            id: "SM",
            icon: <brandIcons.SharedMailbox />,
            name: "Shared Mailbox",
            description: "Address customer queries from emails like support@, sales@ using a shared mailbox accessible to your complete team.",
            learnMoreLink: "https://help.hiverhq.com/getting-started/setting-up-a-shared-mailbox-hiver",
            btnText: "Create Shared Mailbox",
            redirectUrl: CREATE_SM_URL_PATH,
        }, {
            id: "SL",
            icon: <brandIcons.SharedLabel />,
            name: "Shared Label",
            description: "Share new or existing Gmail labels and collaborate on specific conversations with teammates on-demand. Or create shared email repositories on clients, projects, leads etc.",
            learnMoreLink: "https://help.hiverhq.com/shared-labels",
            btnText: "Create Shared Label",
            redirectUrl: CREATE_SL_URL_PATH,
            gainsightEvents: { onCardClick: SL_SUBCARD_CLICKED,
                               onLearnMoreClick: SL_SUBCARD_LEARN_MORE_CLICKED },
        }
    ],
}

export const GUIDE_TO_URLS = {
    email: (inboxId, guideToPath) => `/app/sharedmailbox/edit/${inboxId}/${guideToPath}`,
    chat: (inboxId, guideToPath) => `/app/sharedmailbox/chat/edit/${inboxId}/${guideToPath}`,
    whatsapp: (inboxId, guideToPath) => `/app/sharedmailbox/whatsapp/edit/${inboxId}/${guideToPath}`,
    aircall: (inboxId, guideToPath) => `/app/sharedmailbox/voice/edit/${inboxId}/${guideToPath}`,
}

export const FEATURE_NAME_MAPPING = {
    participants: "Participants",
    autoassignment: "Auto assignment",
    automations: "Automations",
    autoresponder: "Auto responder",
    aliases: "Aliases",
    marketplace: "Integrations",
    approvals: "Approvals",
    csat: "CSAT",
    permalink: "Sharing",
    sla_v2: "SLA",
    settings: "Settings",
    widgetdesign: "Widget design",
    prechatform: "Pre-chat form",
    unavailabilitysettings: "Unavailability settings",
    transcripts: "Transcripts",
    generalsettings: "General settings",
    generalSetting: "General settings",
    configuration: "Configurations",
    manage: "General settings",
    chatbots: "chatbot",
    outofoffice: "Out of Office",
    botConfiguration: "Bot configuration",
    "custom-fields": "Custom fields",
    "kb-articles-in-chat": "Help articles in chat",
    "chatSuggestions": "AI Openers",
    "ai": "AI settings",
    "ai/knowledge_source": "AI copilot",
    "ai/tag-groups/category": "AI Tagging Settings",
}

export const JOIN_HIVER_COMMUNITY = {
    ICON_URL: `${config.CDN_BUNDLE_URL}images/Hiver Community.png`,
    LINK: 'https://hiver-community.slack.com/join/shared_invite/zt-2p8mx8tdt-ubwTQ7befWAajh8KhLeppA#/shared-invite/email',
    TITLE: 'Hiver Slack Community: ',
    DESCRIPTION: 'Ask questions, get answers, and connect with peers.',
    BUTTON_TEXT:'Join Now'
}

export const REDIRECTION_URLS = {
    AI_SETTINGS: "/app/dashboard?guideTo=ai/settings&popupType=email",
    AI_SETTINGS_KB: "/app/dashboard?guideTo=ai/knowledge_source&popupType=email",
    AI_SETTINGS_AUTO_TAGGING: "/app/dashboard?guideTo=ai/tag-groups/category&popupType=email",
    CUSTOM_FIELDS_SETTINGS: "/app/dashboard?guideTo=custom-fields&popupType=email",
}

export const AI_COPILOT_SETUP_NUDGE_USER_PROPERTY = "aiCopilotSetupNudgeDismissed";
export const AI_COPILOT_SETUP_NUDGE_LOCALSTORAGE_KEY = "AiCopilotSetupNudge_cooldown_time";
export const AI_CUSTOM_FIELD_GUIDER_USER_PROPERTY = "ai_custom_field_guider_shown";
export const AI_AUTO_TAG_DISCOVERABILITY_GUIDER_SHOWN_PROPERTY = "ai_auto_tag_setup_discoverability_guider_shown";